import { t } from '@/i18n';
import type { ExportDirective, ExportFilter, ExportFormat } from '@/shared/export/types';
import { CARD_TYPE_FILTERS } from '../constants/cardFilters.constants';
import { cardStatusLabel } from './cardStatusLabels';
import type { CardFilters } from '../types/card.types';

/** Nombre de archivo del PDF de Tarjeta (BF-644). */
export const CARD_PDF_FILENAME = 'reporte_tarjetas.pdf';
export const CARD_XLSX_FILENAME = 'reporte_tarjetas.xlsx';

export interface CardExportInput {
  filters: CardFilters;
  companyName: string;
  companyId: string;
  customerId?: string | null;
}

function optionLabel(
  options: readonly { value: string; labelKey: string }[],
  value: string
): string {
  const option = options.find((item) => item.value === value);
  return option ? t(option.labelKey) : value;
}

/**
 * Construye el directive de export del PDF de Tarjeta (BF-644): manda los
 * filtros aplicados ya resueltos a label/value para el encabezado del reporte.
 */
export function buildCardExportDirective(input: CardExportInput, format: ExportFormat = 'pdf'): ExportDirective {
  const filters: ExportFilter[] = [];

  const search = input.filters.search?.trim();
  if (search) filters.push({ label: t('dashboard.card.filters.emailLabel'), value: search });
  if (input.filters.status) {
    filters.push({
      label: t('dashboard.card.filters.statusLabel'),
      value: cardStatusLabel(input.filters.status),
    });
  }
  if (input.filters.type) {
    filters.push({
      label: t('dashboard.card.filters.typeLabel'),
      value: optionLabel(CARD_TYPE_FILTERS, input.filters.type),
    });
  }
  if (input.filters.tags && input.filters.tags.length > 0) {
    filters.push({
      label: t('dashboard.card.filters.labelLabel'),
      value: input.filters.tags.join(', '),
    });
  }

  return {
    report: 'cards',
    format,
    companyName: input.companyName,
    companyId: input.companyId,
    customerId: input.customerId ?? null,
    filters,
  };
}
